/**
 * Plugin for save newsletter preferencese (with ajax call) in account page
 *
 * @author: Botond Szasz <bszasz@zerogrey.com>
 *
 */

(function ( $ ) {

	"use strict";

	/**
	 * @selector data-zg-role="newsletter-preferences" The plugin start if there is the selector (form) in the dom when the page load
	 */

	var toggle             = '[data-zg-role="newsletter-preferences"]';
	var accept_toggle      = '[data-zg-role="newsletter-accept"]';
	var user_id_toggle     = '[data-zg-role="newsletter-user-id"]';
	var merchant_id_toggle = '[data-zg-role="newsletter-merchant-id"]';

	//@todo - add the custom field selector
	var custom_fields_marketing_preferences = '[data-zg-role="user_marketing_preferences"]';
	var custom_fields = '[data-zg-role="custom_fields"]';

	var ZG_NewsletterPreferences = function ( element, config ) {
		var self = this;
		this.init = function ( element, config ) {
			var $element     = $(element);
			self.$eventBus   = $(document);
			self.$element    = $element;
			self.$accept     = self.$element.find( accept_toggle );
			self.$userId     = self.$element.find( user_id_toggle );
			self.$merchantId = self.$element.find( merchant_id_toggle );

			// @todo - add custom fields to the options
			self.$customFieldsMarketingPreferences = self.$element.find( custom_fields_marketing_preferences );
			self.$customFields = self.$element.find( custom_fields );

			self.$element.on('submit', self.savePreferences );
		};
		this.savePreferences = function ( event ) {
			event.preventDefault();
			event.stopPropagation();
			if ( self.$element.data('zgValidator') ) {
				if ( !self.$element.data('zgValidator').validate() ) {
					return false;
				}
			}
			var request = {
					"accept_newsletter": self.$accept.is(':checked') ? self.$accept.val() : 0,
					"userId"           : self.$userId.val(),
					"merchantId"       : self.$merchantId.val(),
				};

			// @todo - create and populate an object to pass the custom fields
			var custom_field_data = {};
			$(self.$customFieldsMarketingPreferences).each(function(){
				if( $(this).is(':checked') ) custom_field_data[$(this).attr('id')] = "1";
				else custom_field_data[$(this).attr('id')] = "0";
			});
			$(self.$customFields).each(function(){
				custom_field_data[$(this).attr('id')] = $(this).val();
			});

			// @todo - add the custom field data to the request
			request.user_custom_fields = custom_field_data;

			var url = window.makeUrl({module: 'eshop', manager: 'eshop', action: 'updateNewsletterPreferences'});
			$.post( url, request, function ( response ) {
				if ( response.status == "success" ) {
					self.$eventBus.trigger('zg-notification', [{
						eventType: 'newsletter-preferences-saved',
						message: response.message || 'Newsletter have been saved'
					}]);
				} else {
					self.$eventBus.trigger('zg-error', [{
						eventType: 'newsletter-preferences-saved',
						message: response.message || 'Newsletter could not be saved'
					}]);
				}
			}, 'json');
			return false;
		};
		this.init( element, config );
	};

	$.fn.zg_newsletter_preferences = function ( config ) {
		return this.each( function () {
			var $this = $(this);
			var data  = $this.data('zgNewsletterPreferences');
			if (!data) {
				$this.data('zgNewsletterPreferences', (data = new ZG_NewsletterPreferences(this, config)) );
			}
		} );
	};

	$(function () {
		$('body').find( toggle ).zg_newsletter_preferences( window.ZG_CONFIG );
	});

})( jQuery );